import { createFileRoute } from "@tanstack/react-router";
import type { Row } from "@tanstack/react-table";
import { zodValidator } from "@tanstack/zod-adapter";
import { useState } from "react";

import ActionButton from "@/components/Button/ActionButton";
import { DataTable } from "@/components/DataTable";
import { FillScreen, HStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

import { DeviceAssignmentDialog } from "../assignments/-components/device-assignment-dialog";

import { InventoryTabs, useInventoryTabs } from "./-components/InventoryTabs";
import { SearchSchema } from "./-constants";
import { useLicensePeopleTable } from "./-hooks/useLicensePeopleTable";
import type { LicensePeopleTableRow } from "./-types";

export const Route = createFileRoute("/_staff/licenses/$id/_profile/people/")({
  validateSearch: zodValidator(SearchSchema),
  component: LicensePeople,
});

function LicensePeople() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.licenses.detailPeople",
  });

  const { id } = Route.useParams();
  const navigate = Route.useNavigate();
  const { table, displayState, counts } = useLicensePeopleTable();
  const inventoryTabsProps = useInventoryTabs();
  const [isOpen, setIsOpen] = useState(false);

  const handleRowClick = (row: Row<LicensePeopleTableRow>) => {
    if (!row.original.assignedUser?.id) return;
    navigate({
      to: "/person/$id",
      params: { id: row.original.assignedUser.id },
    });
  };

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="gap-2 items-center">
        <InventoryTabs
          counts={counts}
          onChange={inventoryTabsProps.onChange}
          value={inventoryTabsProps.value}
        />
        <span className="ml-auto">
          <ActionButton
            variant="secondary"
            size="sm"
            onClick={() => setIsOpen(true)}
          >
            {t("assignButton")}
          </ActionButton>
        </span>
        <DeviceAssignmentDialog
          licenseId={id}
          title={t("deviceAssignmentDialog.title")}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSuccess={() => {}}
        />
      </HStack>
      <DataTable
        table={table}
        displayState={displayState}
        onRowClick={handleRowClick}
      />
    </FillScreen>
  );
}
